
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Logo"}},[_c('path',{attrs:{"fill":"#000","d":"M500 250C500 111.9 388.1 0 250 0S0 111.9 0 250c0 117.2 80.7 215.6 189.6 242.6V326.4H138V250h51.6v-32.9c0-85.1 38.5-124.5 122-124.5 15.8 0 43.2 3.1 54.3 6.2V168c-5.9-.6-16.1-.9-28.9-.9-41 0-56.8 15.5-56.8 55.9v27h81.7l-14 76.4h-67.6v171.8C404.1 483.2 500 377.8 500 250Z"}})])])
          )
        }
      }
    